import { render, staticRenderFns } from "./ListCardReportInfo.vue?vue&type=template&id=4f143232&"
import script from "./ListCardReportInfo.vue?vue&type=script&lang=js&"
export * from "./ListCardReportInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports